module.exports = __webpack_public_path__ + "static/media/question_image.da4bb51c.png";